import {CallbackProps, CommunicationsMessageFilters, ValueProps} from "./presentation";
import {connect, Store} from "react-redux";
import {State} from "./reducers";
import {Message, MessageId, OpenedStatus, SentStatus} from "./data";
import {CommunicationsMessageFiltersAction, CommunicationsMessageFiltersActionWrapper} from "./actions";
import {compose, Dispatcher} from "../../../lib/utils";
import {Action} from "redux";

export type CommunicationsMessageFiltersStore = Store<State>

export type OwnProps = {
	store: CommunicationsMessageFiltersStore
	messages: Message[]
}

const mapStateToProps = (state: State, ownProps: OwnProps): ValueProps => ({
	...state,
	messages: ownProps.messages
})

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>, ownProps: OwnProps): CallbackProps => {
	const wrap = (action: CommunicationsMessageFiltersAction): CommunicationsMessageFiltersActionWrapper => ({
		type: "communications message filters action",
		action: action
	})
	const dispatchAction = compose(wrap, dispatch)

	return {
		setMessages: (messages: MessageId[]) => dispatchAction({type: "set messages", messages}),
		setSentStatus: (sentStatus: SentStatus) => dispatchAction({type: "set sent status", sentStatus}),
		setOpenedStatus: (openedStatus: OpenedStatus) => dispatchAction({type: "set opened status", openedStatus})
	}
}

export const CommunicationsMessageFiltersApp = connect<ValueProps, CallbackProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps
)(CommunicationsMessageFilters)



// WEBPACK FOOTER //
// ./src/contacts/querybuilder-filters/communications-message/app.ts